<template>
  <div>
    <div class="bg-blue-gray-50">
      <!-- noprint-area -->
      <div
        class="hide-print flex flex-row h-screen antialiased text-blue-gray-800"
      >
        <!-- left sidebar -->
        <div class="flex flex-row w-auto flex-shrink-0 pl-4 pr-2 py-4">
          <div
            :style="{ 'background-color': getThemeColor }"
            class="flex flex-col items-center py-4 flex-shrink-0 w-20 rounded-3xl"
          >
            <a
              :style="{
                display: 'inline-block',
                width: '50px',
                height: '14px',
              }"
              href="#"
              class="flex items-center justify-center text-cyan-700 rounded-full"
            >
              <svg
                class="mt-0 ml-1"
                xmlns="http://www.w3.org/2000/svg"
                width="43.3"
                height="43.233"
                viewBox="0 0 32.623 32.605"
              >
                <path
                  d="M15.612 0c-.36.003-.705.01-1.03.021C8.657.223 5.742 1.123 3.4 3.472.714 6.166-.145 9.758.019 17.607c.137 6.52.965 9.271 3.542 11.768 1.31 1.269 2.658 2 4.73 2.57.846.232 2.73.547 3.56.596.36.021 2.336.048 4.392.06 3.162.018 4.031-.016 5.63-.221 3.915-.504 6.43-1.778 8.234-4.173 1.806-2.396 2.514-5.731 2.516-11.846.001-4.407-.42-7.59-1.278-9.643-1.463-3.501-4.183-5.53-8.394-6.258-1.634-.283-4.823-.475-7.339-.46z"
                  fill="#fff"
                />
                <path
                  d="M16.202 13.758c-.056 0-.11 0-.16.003-.926.031-1.38.172-1.747.538-.42.421-.553.982-.528 2.208.022 1.018.151 1.447.553 1.837.205.198.415.313.739.402.132.036.426.085.556.093.056.003.365.007.686.009.494.003.63-.002.879-.035.611-.078 1.004-.277 1.286-.651.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.147-.072zM16.22 19.926c-.056 0-.11 0-.16.003-.925.031-1.38.172-1.746.539-.42.42-.554.981-.528 2.207.02 1.018.15 1.448.553 1.838.204.198.415.312.738.4.132.037.426.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.034.61-.08 1.003-.278 1.285-.652.282-.374.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.863-1.31-.977a7.91 7.91 0 00-1.146-.072zM22.468 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.205.198.415.313.739.401.132.037.426.086.556.094.056.003.364.007.685.009.494.003.63-.002.88-.035.611-.078 1.004-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.065-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072z"
                  fill="#00dace"
                />
                <path
                  d="M9.937 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.204.198.415.313.738.401.133.037.427.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.035.61-.078 1.003-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072zM16.202 7.59c-.056 0-.11 0-.16.002-.926.032-1.38.172-1.747.54-.42.42-.553.98-.528 2.206.022 1.019.151 1.448.553 1.838.205.198.415.312.739.401.132.037.426.086.556.093.056.003.365.007.686.01.494.002.63-.003.879-.035.611-.079 1.004-.278 1.286-.652.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.505-.228-.547-.653-.864-1.31-.978a7.91 7.91 0 00-1.147-.071z"
                  fill="#00bcd4"
                />
                <g>
                  <path
                    d="M15.612 0c-.36.003-.705.01-1.03.021C8.657.223 5.742 1.123 3.4 3.472.714 6.166-.145 9.758.019 17.607c.137 6.52.965 9.271 3.542 11.768 1.31 1.269 2.658 2 4.73 2.57.846.232 2.73.547 3.56.596.36.021 2.336.048 4.392.06 3.162.018 4.031-.016 5.63-.221 3.915-.504 6.43-1.778 8.234-4.173 1.806-2.396 2.514-5.731 2.516-11.846.001-4.407-.42-7.59-1.278-9.643-1.463-3.501-4.183-5.53-8.394-6.258-1.634-.283-4.823-.475-7.339-.46z"
                    fill="#fff"
                  />
                  <path
                    d="M16.202 13.758c-.056 0-.11 0-.16.003-.926.031-1.38.172-1.747.538-.42.421-.553.982-.528 2.208.022 1.018.151 1.447.553 1.837.205.198.415.313.739.402.132.036.426.085.556.093.056.003.365.007.686.009.494.003.63-.002.879-.035.611-.078 1.004-.277 1.286-.651.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.147-.072zM16.22 19.926c-.056 0-.11 0-.16.003-.925.031-1.38.172-1.746.539-.42.42-.554.981-.528 2.207.02 1.018.15 1.448.553 1.838.204.198.415.312.738.4.132.037.426.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.034.61-.08 1.003-.278 1.285-.652.282-.374.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.863-1.31-.977a7.91 7.91 0 00-1.146-.072zM22.468 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.205.198.415.313.739.401.132.037.426.086.556.094.056.003.364.007.685.009.494.003.63-.002.88-.035.611-.078 1.004-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.065-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072z"
                    fill="#00dace"
                  />
                  <path
                    d="M9.937 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.204.198.415.313.738.401.133.037.427.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.035.61-.078 1.003-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072zM16.202 7.59c-.056 0-.11 0-.16.002-.926.032-1.38.172-1.747.54-.42.42-.553.98-.528 2.206.022 1.019.151 1.448.553 1.838.205.198.415.312.739.401.132.037.426.086.556.093.056.003.365.007.686.01.494.002.63-.003.879-.035.611-.079 1.004-.278 1.286-.652.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.505-.228-.547-.653-.864-1.31-.978a7.91 7.91 0 00-1.147-.071z"
                    fill="#00bcd4"
                  />
                </g>
              </svg>
            </a>

            <ul class="flex flex-col space-y-2 mt-12">
              <li>
                <a href="#" class="flex items-center">
                  <span
                    class="flex items-center justify-center h-12 w-12 rounded-2xl"
                    x-bind:class="{
                  'hover:bg-cyan-400 text-cyan-100': activeMenu !== 'pos',
                  'bg-cyan-300 shadow-lg text-white': activeMenu === 'pos',
                }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li>
                <a href="#" class="flex items-center">
                  <span
                    class="flex items-center justify-center text-cyan-100 hover:bg-cyan-400 h-12 w-12 rounded-2xl"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li>
                <a href="#" class="flex items-center">
                  <span
                    class="flex items-center justify-center text-cyan-100 hover:bg-cyan-400 h-12 w-12 rounded-2xl"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      />
                    </svg>
                  </span>
                </a>
              </li>
              <li>
                <a href="#" class="flex items-center">
                  <span
                    class="flex items-center justify-center text-cyan-100 hover:bg-cyan-400 h-12 w-12 rounded-2xl"
                  >
                    <svg
                      class="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                    </svg>
                  </span>
                </a>
              </li>
            </ul>
            <!-- <a
              href="https://github.com/emsifa/tailwind-pos"
              target="_blank"
              class="mt-auto flex items-center justify-center text-cyan-200 hover:text-cyan-100 h-10 w-10 focus:outline-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-8 w-8"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clip-rule="evenodd"
                />
              </svg>
            </a> -->
          </div>
        </div>

        <!-- page content -->
        <div class="flex-grow flex">
          <!-- store menu -->
          <div class="flex flex-col bg-blue-gray-50 h-full w-full py-4">
            <div class="flex px-2 flex-row relative">
              <div
                class="absolute left-5 top-3 px-2 py-2 rounded-full bg-cyan-500 text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                type="text"
                class="bg-white rounded-3xl shadow text-lg full w-full h-16 py-4 pl-16 transition-shadow focus:shadow-2xl focus:outline-none"
                placeholder="Cari menu ..."
                v-model="keyword"
              />
            </div>
            <div class="h-full overflow-auto mt-4">
              <div class="h-full overflow-y-auto px-2">
                <div
                  class="select-none bg-blue-gray-100 rounded-3xl flex flex-wrap content-center justify-center h-full opacity-25"
                  v-if="products.length === 0"
                >
                  <div class="w-full text-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-24 w-24 inline-block"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                      />
                    </svg>
                    <p class="text-xl">
                      YOU DON'T HAVE
                      <br />
                      ANY PRODUCTS TO SHOW
                    </p>
                  </div>
                </div>
                <div
                  class="select-none bg-blue-gray-100 rounded-3xl flex flex-wrap content-center justify-center h-full opacity-25"
                  v-if="products.length === 0 && keyword.length > 0"
                >
                  <div class="w-full text-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-24 w-24 inline-block"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                    <p class="text-xl">
                      EMPTY SEARCH RESULT
                      <br />
                      "<span v-text="keyword" class="font-semibold"></span>"
                    </p>
                  </div>
                </div>
                <div
                  v-if="products.length"
                  class="grid sm:grid-cols-4 grid-cols-1 sm:gap-4 gap-2 pb-3"
                >
                  <div v-for="(product, pid) in products" :key="pid">
                    <div
                      role="button"
                      class="select-none cursor-pointer transition-shadow overflow-hidden rounded-2xl bg-white shadow hover:shadow-lg"
                      :title="product.name"
                      @click="addToCart(product)"
                    >
                      <img
                        class="text-center justify-center mx-auto mt-2"
                        :style="{
                          'border-radius': '50px',
                          'max-height': '120px',
                          'max-width': '120px',
                        }"
                        :src="
                          product.image
                            ? product.image
                            : '/images/products/no-photo.jpg'
                        "
                        :alt="product.name"
                      />
                      <div class="flex pb-3 px-3 text-sm -mt-3">
                        <p
                          class="flex-grow truncate mr-1 mt-2"
                          v-text="product.name"
                        ></p>
                      </div>
                      <div class="flex px-3 text-sm -mt-6">
                        <p
                          class="nowrap font-semibold"
                          v-text="formatMoney(product.price)"
                        ></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end of store menu -->

          <!-- right sidebar -->
          <div
            class="sm:w-5/12 w-40 flex flex-col bg-blue-gray-50 h-full bg-white sm:pr-4 sm:pl-2 py-4"
          >
            <div class="bg-white rounded-3xl flex flex-col h-full shadow">
              <!-- empty cart -->
              <div
                v-if="cart.length === 0"
                class="flex-1 w-full p-4 opacity-25 select-none flex flex-col flex-wrap content-center justify-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-16 inline-block"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                <p>CART EMPTY</p>
              </div>

              <!-- cart items -->
              <div v-else class="flex-1 flex flex-col overflow-auto">
                <!-- cart items -->
                <div class="flex-1 w-full sm:px-4 ml-1 overflow-auto">
                  <div v-for="item in cart" :key="item.productId">
                    <div
                      class="select-none mb-3 bg-blue-gray-50 rounded-lg w-full text-blue-gray-700 py-2 px-2 flex text-center justify-center"
                    >
                      <img
                        v-if="!isMobile"
                        :src="item.image"
                        alt=""
                        class="rounded-lg h-10 w-10 bg-white shadow mr-2"
                      />
                      <div class="flex-grow">
                        <h5 class="text-sm" v-text="item.name"></h5>

                        <p class="text-xs block">
                          {{ formatMoney(item.price) }}
                        </p>
                      </div>
                      <div class="py-1">
                        <div
                          class="sm:w-28 grid grid-cols-3 sm:gap-2 gap-1 ml-2"
                        >
                          <button
                            @click="addQty(item, -1)"
                            class="sm:rounded-lg rounded-md text-center py-1 text-white bg-blue-gray-600 hover:bg-blue-gray-700 focus:outline-none"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-3 inline-block"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M20 12H4"
                              />
                            </svg>
                          </button>
                          <input
                            v-model.number="item.qty"
                            type="text"
                            class="bg-white rounded-lg text-center shadow focus:outline-none focus:shadow-lg text-sm"
                          />
                          <button
                            @click="addQty(item, 1)"
                            class="rounded-lg text-center py-1 text-white bg-blue-gray-600 hover:bg-blue-gray-700 focus:outline-none"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-3 inline-block"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end of cart items -->

              <!-- payment info -->
              <div class="select-none h-auto w-full text-center pt-3 pb-4 px-4">
                <div
                  class="flex mb-3 sm:text-lg text-sm font-semibold text-blue-gray-700"
                >
                  <div class="text-left">TOTAL</div>
                  <div
                    class="text-right w-full"
                    v-text="formatMoney(getTotalPrice())"
                  ></div>
                </div>
                <div
                  class="mb-3 text-blue-gray-700 px-3 pt-2 pb-3 rounded-lg bg-blue-gray-50"
                >
                  <div class="flex sm:text-lg text-sm font-semibold">
                    <div class="flex text-right">
                      <div class="mr-2">{{ getCurrency }}</div>
                      <input
                        placeholder="0"
                        :value="cash"
                        @keyup="updateCash($event.target.value)"
                        type="text"
                        class="text-right w-full bg-white shadow rounded-lg focus:bg-white focus:shadow-lg px-2 focus:outline-none"
                      />
                    </div>
                  </div>
                  <div class="text-right font-semibold">PAID</div>
                  <hr class="my-2" />
                  <!-- <div class="grid sm:grid-cols-3 gap-2 mt-2">
                    <div v-for="money in moneys" :key="money">
                      <button
                        @click="addCash(money)"
                        class="bg-white rounded-lg shadow hover:shadow-lg focus:outline-none inline-block px-2 py-1 text-sm"
                      >
                        +<span v-text="formatMoney(money)"></span>
                      </button>
                    </div>
                  </div> -->
                </div>

                <div
                  v-if="change >= 0"
                  class="mb-3 sm:text-lg text-sm font-semibold bg-cyan-50 text-blue-gray-700 rounded-lg py-2 px-3"
                >
                  <div
                    class="text-right flex-grow text-cyan-600"
                    v-text="formatMoney(change)"
                  ></div>
                  <div class="text-cyan-800 text-right">CHANGE</div>
                </div>

                <div
                  v-else
                  class="mb-3 sm:text-lg text-sm font-semibold bg-pink-100 text-blue-gray-700 rounded-lg py-2 px-3"
                >
                  <div
                    class="text-right flex-grow text-pink-600"
                    v-text="formatMoney(change)"
                  ></div>
                  <div class="text-cyan-800 text-right">CHANGE</div>
                </div>
                <div
                  v-if="change == 0 && cart.length > 0"
                  class="flex justify-center mb-3 text-lg font-semibold bg-cyan-50 text-cyan-700 rounded-lg py-2 px-3"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 inline-block"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                    />
                  </svg>
                </div>
                <button
                  :class="'text-white rounded-2xl text-lg w-full py-3 focus:outline-none bg-cyan-500 hover:bg-cyan-600'"
                  :style="{ 'background-color': getThemeColor }"
                  @click="submit()"
                >
                  SUBMIT
                </button>
              </div>
              <!-- end of payment info -->
            </div>
          </div>
          <!-- end of right sidebar -->
        </div>

        <!-- modal first time -->
        <!-- <div v-if="firstTime" class="fixed glass w-full h-screen left-0 top-0 z-10 flex flex-wrap justify-center content-center p-24">
      <div class="w-96 rounded-3xl p-8 bg-white shadow-xl">
        <div class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="inline-block" width="123.3" height="123.233" viewBox="0 0 32.623 32.605">
            <path d="M15.612 0c-.36.003-.705.01-1.03.021C8.657.223 5.742 1.123 3.4 3.472.714 6.166-.145 9.758.019 17.607c.137 6.52.965 9.271 3.542 11.768 1.31 1.269 2.658 2 4.73 2.57.846.232 2.73.547 3.56.596.36.021 2.336.048 4.392.06 3.162.018 4.031-.016 5.63-.221 3.915-.504 6.43-1.778 8.234-4.173 1.806-2.396 2.514-5.731 2.516-11.846.001-4.407-.42-7.59-1.278-9.643-1.463-3.501-4.183-5.53-8.394-6.258-1.634-.283-4.823-.475-7.339-.46z" fill="#fff"/><path d="M16.202 13.758c-.056 0-.11 0-.16.003-.926.031-1.38.172-1.747.538-.42.421-.553.982-.528 2.208.022 1.018.151 1.447.553 1.837.205.198.415.313.739.402.132.036.426.085.556.093.056.003.365.007.686.009.494.003.63-.002.879-.035.611-.078 1.004-.277 1.286-.651.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.147-.072zM16.22 19.926c-.056 0-.11 0-.16.003-.925.031-1.38.172-1.746.539-.42.42-.554.981-.528 2.207.02 1.018.15 1.448.553 1.838.204.198.415.312.738.4.132.037.426.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.034.61-.08 1.003-.278 1.285-.652.282-.374.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.863-1.31-.977a7.91 7.91 0 00-1.146-.072zM22.468 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.205.198.415.313.739.401.132.037.426.086.556.094.056.003.364.007.685.009.494.003.63-.002.88-.035.611-.078 1.004-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.065-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072z" fill="#00dace"/><path d="M9.937 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.204.198.415.313.738.401.133.037.427.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.035.61-.078 1.003-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072zM16.202 7.59c-.056 0-.11 0-.16.002-.926.032-1.38.172-1.747.54-.42.42-.553.98-.528 2.206.022 1.019.151 1.448.553 1.838.205.198.415.312.739.401.132.037.426.086.556.093.056.003.365.007.686.01.494.002.63-.003.879-.035.611-.079 1.004-.278 1.286-.652.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.505-.228-.547-.653-.864-1.31-.978a7.91 7.91 0 00-1.147-.071z" fill="#00bcd4"/><g><path d="M15.612 0c-.36.003-.705.01-1.03.021C8.657.223 5.742 1.123 3.4 3.472.714 6.166-.145 9.758.019 17.607c.137 6.52.965 9.271 3.542 11.768 1.31 1.269 2.658 2 4.73 2.57.846.232 2.73.547 3.56.596.36.021 2.336.048 4.392.06 3.162.018 4.031-.016 5.63-.221 3.915-.504 6.43-1.778 8.234-4.173 1.806-2.396 2.514-5.731 2.516-11.846.001-4.407-.42-7.59-1.278-9.643-1.463-3.501-4.183-5.53-8.394-6.258-1.634-.283-4.823-.475-7.339-.46z" fill="#fff"/><path d="M16.202 13.758c-.056 0-.11 0-.16.003-.926.031-1.38.172-1.747.538-.42.421-.553.982-.528 2.208.022 1.018.151 1.447.553 1.837.205.198.415.313.739.402.132.036.426.085.556.093.056.003.365.007.686.009.494.003.63-.002.879-.035.611-.078 1.004-.277 1.286-.651.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.147-.072zM16.22 19.926c-.056 0-.11 0-.16.003-.925.031-1.38.172-1.746.539-.42.42-.554.981-.528 2.207.02 1.018.15 1.448.553 1.838.204.198.415.312.738.4.132.037.426.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.034.61-.08 1.003-.278 1.285-.652.282-.374.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.863-1.31-.977a7.91 7.91 0 00-1.146-.072zM22.468 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.205.198.415.313.739.401.132.037.426.086.556.094.056.003.364.007.685.009.494.003.63-.002.88-.035.611-.078 1.004-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.065-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072z" fill="#00dace"/><path d="M9.937 13.736c-.056 0-.11.001-.161.003-.925.032-1.38.172-1.746.54-.42.42-.554.98-.528 2.207.021 1.018.15 1.447.553 1.837.204.198.415.313.738.401.133.037.427.086.556.094.056.003.365.007.686.009.494.003.63-.002.88-.035.61-.078 1.003-.277 1.285-.651.282-.375.393-.895.393-1.85 0-.688-.066-1.185-.2-1.506-.228-.547-.653-.864-1.31-.977a7.91 7.91 0 00-1.146-.072zM16.202 7.59c-.056 0-.11 0-.16.002-.926.032-1.38.172-1.747.54-.42.42-.553.98-.528 2.206.022 1.019.151 1.448.553 1.838.205.198.415.312.739.401.132.037.426.086.556.093.056.003.365.007.686.01.494.002.63-.003.879-.035.611-.079 1.004-.278 1.286-.652.282-.374.392-.895.393-1.85 0-.688-.066-1.185-.2-1.505-.228-.547-.653-.864-1.31-.978a7.91 7.91 0 00-1.147-.071z" fill="#00bcd4"/></g>
          </svg>
          <h3 class="text-center text-2xl mb-8">FIRST TIME?</h3>
        </div>
        <div class="text-left">
          <button @click="startWithSampleData()" class="text-left w-full mb-3 rounded-xl bg-blue-gray-500 text-white focus:outline-none hover:bg-cyan-400 px-4 py-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline-block -mt-1 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20" />
            </svg>
            LOAD SAMPLE DATA
          </button>
          <button @click="startBlank()" class="text-left w-full rounded-xl bg-blue-gray-500 text-white focus:outline-none hover:bg-teal-400 px-4 py-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline-block -mt-1 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
            LEAVE IT EMPTY
          </button>
        </div>
      </div>
    </div> -->

        <!-- modal receipt -->
        <div
          v-if="isShowModalReceipt"
          class="fixed w-full h-screen left-0 top-0 z-10 flex flex-wrap justify-center content-center p-24"
        >
          <div
            v-if="isShowModalReceipt"
            class="fixed glass w-full h-screen left-0 top-0 z-0"
            @click="closeModalReceipt()"
            x-transition:enter="transition ease-out duration-100"
            x-transition:enter-start="opacity-0"
            x-transition:enter-end="opacity-100"
            x-transition:leave="transition ease-in duration-100"
            x-transition:leave-start="opacity-100"
            x-transition:leave-end="opacity-0"
          ></div>
          <div
            v-if="isShowModalReceipt"
            class="w-96 rounded-3xl bg-white shadow-xl overflow-hidden z-10"
            x-transition:enter="transition ease-out duration-100"
            x-transition:enter-start="opacity-0 transform scale-90"
            x-transition:enter-end="opacity-100 transform scale-100"
            x-transition:leave="transition ease-in duration-100"
            x-transition:leave-start="opacity-100 transform scale-100"
            x-transition:leave-end="opacity-0 transform scale-90"
          >
            <div
              id="receipt-content"
              class="text-left w-full text-sm p-6 overflow-auto"
            >
              <div class="text-center">
                <img
                  :src="
                    getApiUrl +
                    '/images/logos/' +
                    getUserCompany.emis +
                    '/' +
                    logos[0]
                  "
                  :alt="getUserCompany.name"
                  class="mb-3 w-8 h-8 inline-block"
                />
                <h2 class="text-xl font-semibold">{{ getUserCompany.name }}</h2>
                <p>{{ getUserCompany.primary_address }}</p>
              </div>
              <div class="flex mt-4 text-xs">
                <div class="flex-grow">
                  No: <span v-text="receiptNo"></span>
                </div>
                <div v-text="receiptDate"></div>
              </div>
              <hr class="my-2" />
              <div>
                <table class="w-full text-xs">
                  <thead>
                    <tr>
                      <th class="py-1 w-1/12 text-center">#</th>
                      <th class="py-1 text-left">Item</th>
                      <th class="py-1 w-2/12 text-center">Qty</th>
                      <th class="py-1 w-3/12 text-right">Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in cart" :key="item">
                      <td class="py-2 text-center" v-text="index + 1"></td>
                      <td class="py-2 text-left">
                        <span v-text="item.name"></span>
                        <br />
                        <small v-text="formatMoney(item.price)"></small>
                      </td>
                      <td class="py-2 text-center" v-text="item.qty"></td>
                      <td
                        class="py-2 text-right"
                        v-text="formatMoney(item.qty * item.price)"
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <hr class="my-2" />
              <div>
                <div class="flex font-semibold">
                  <div class="flex-grow">TOTAL</div>
                  <div v-text="formatMoney(getTotalPrice())"></div>
                </div>
                <div class="flex text-xs font-semibold">
                  <div class="flex-grow">PAY AMOUNT</div>
                  <div v-text="formatMoney(cash)"></div>
                </div>
                <hr class="my-2" />
                <div class="flex text-xs font-semibold">
                  <div class="flex-grow">CHANGE</div>
                  <div v-text="formatMoney(change)"></div>
                </div>
              </div>
            </div>
            <div class="p-4 w-full">
              <button
                :style="{ 'background-color': getThemeColor }"
                class="text-white text-lg px-4 py-3 rounded-2xl w-full focus:outline-none"
                @click="printAndProceed()"
              >
                PRINT
              </button>
            </div>
          </div>
        </div>
        <!--End of Modal-->
      </div>
      <!-- end of noprint-area -->

      <div id="print-area" class="print-area"></div>
    </div>
  </div>
</template>

<script>
import productsAndServices from "@/plugins/productsAndServices";
import helpersJs from "@/plugins/helpers";

export default {
  name: "POS",
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  data: () => ({
    logos: [],
    item: { productId: 1 },
    productId: 1,
    db: null,
    time: null,
    firstTime: null,
    activeMenu: "pos",
    loadingSampleData: false,
    moneys: [2000, 5000, 10000, 20000, 50000, 100000],
    keyword: "",
    cart: [],
    cash: "",
    change: 0,
    isShowModalReceipt: false,
    receiptNo: null,
    receiptDate: null,
    product: {
      id: 1,
      name: "Beef Burger",
      price: 45000,
      image: "img/beef-burger.png",
      options: null,
    },
    products: [
      {
        id: 1,
        name: "Beef Burger",
        price: 95.99,
        image:
          "https://feelgoodfoodie.net/wp-content/uploads/2020/07/Homemade-Hamburgers-TIMG.jpg",
        options: null,
      },
      {
        id: 2,
        name: "Sandwich",
        price: 69,
        image:
          "https://simply-delicious-food.com/wp-content/uploads/2020/07/Easy-salad-sandwiches-with-herb-mayo-5.jpg",
        options: null,
      },
      {
        id: 3,
        name: "Schwarma",
        price: 45,
        image:
          "https://i.guim.co.uk/img/media/698fd183dc12485059346ec795d4b1325d5b25bc/275_1424_2872_2872/master/2872.jpg?width=465&dpr=1&s=none",
        options: null,
      },
      {
        id: 4,
        name: "Croissant",
        price: 39,
        image:
          "https://www.theflavorbender.com/wp-content/uploads/2020/05/French-Croissants-SM-2363.jpg",
        options: null,
      },
      {
        id: 5,
        name: "Cinnamon Roll",
        price: 55,
        image:
          "https://cambreabakes.com/wp-content/uploads/2024/03/best-cinnamon-rolls-featured.jpg",
        options: null,
      },
      {
        id: 6,
        name: "Choco Glaze Donut with Peanut",
        price: 74.99,
        image:
          "https://www.crazyforcrust.com/wp-content/uploads/2021/04/chocolate-glazed-peanut-butter-donuts-5.jpg",
        options: null,
      },
      {
        id: 7,
        name: "Choco Glazed Donut",
        price: 89,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZUNGbEtSAaqh9gyws0fdYWdRX__xonXSefw&s",
        options: null,
      },
      {
        id: 8,
        name: "Red Glazed Donut",
        price: 35,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcx1g2oa2-dBhSSPpKmEx5vrWeacmybX03Ug&s",
        options: null,
      },
      {
        id: 9,
        name: "Iced Coffee Latte",
        price: 31.99,
        image:
          "https://images.immediate.co.uk/production/volatile/sites/30/2020/08/iced-latte-30188f7.jpg?quality=90&resize=440,400",
        options: null,
      },
      {
        id: 10,
        name: "Iced Chocolate",
        price: 25,
        image:
          "https://images.immediate.co.uk/production/volatile/sites/30/2020/08/iced-latte-30188f7.jpg?quality=90&resize=440,400",
        options: null,
      },
      {
        id: 11,
        name: "Iced Tea",
        price: 15,
        image:
          "https://shop.westrockcoffee.com/cdn/shop/products/itced_tea_pitcher_5fc70ae9-deff-4c91-ab18-e143b8350638.jpg?v=1625082410",
        options: null,
      },
      {
        id: 12,
        name: "Iced Matcha Latte",
        price: 22.99,
        image:
          "https://munchingwithmariyah.com/wp-content/uploads/2020/06/IMG_0748.jpg",
        options: null,
      },
      {
        id: 13,
        name: "Braai Combo",
        price: 229,
        image:
          "https://cdn11.bigcommerce.com/s-5sp1o94etn/product_images/uploaded_images/blog-cover.jpg",
        options: null,
      },
      {
        id: 14,
        name: "Solva Braai",
        price: 168,
        image:
          "https://souvlabraai.co.za/wp-content/uploads/2024/01/Souvla-Braai-Marine-Souvla-4.jpg",
        options: null,
      },
      {
        id: 15,
        name: "Grilled Pork",
        price: 199,
        image:
          "https://www.allrecipes.com/thmb/gbMu9ffS-EnGHt1yShdmfVjzD5k=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/14726-grilled-pork-tenderloin-beauty-3x4-f4efabb5032f464dae47fe4ee57690da.jpg",
        options: null,
      },
      {
        id: 16,
        name: "Roasted Pork",
        price: 299,
        image:
          "https://assets.bonappetit.com/photos/5c004e76037f9b5d60b6ca3d/1:1/w_2560%2Cc_limit/bone-in-pork-loin.jpg",
        options: null,
      },
      {
        id: 17,
        name: "Barbecue Ribs",
        price: 249,
        image:
          "https://www.spendwithpennies.com/wp-content/uploads/2022/06/Oven-Baked-Ribs-SpendWithPennies-4.jpg",
        options: null,
      },
      {
        id: 18,
        name: "Potatoes Chips",
        price: 49,
        image:
          "https://www.thespruceeats.com/thmb/AxgERyL88tzebyGhS0n6daq4Ojg=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/best-twice-cooked-chip-recipe-434891-hero-01-5d90eb5142b042e1b71e2c3bcce9c5c9.jpg",
        options: null,
      },
      {
        id: 19,
        name: "Rounded Chips",
        price: 39,
        image:
          "https://assets.bonappetit.com/photos/57ad30ab1b3340441497549f/master/pass/crispiest-potato-chips.jpg",
        options: null,
      },
      {
        id: 20,
        name: "Salted Chips",
        price: 38,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4KZkn9FhXO1njhZnbunM-0Z2GiPrjXXilqg&s",
        options: null,
      },
      {
        id: 21,
        name: "Jollof with Chicken",
        price: 65,
        image:
          "https://travelandmunchies.com/wp-content/uploads/2022/11/IMG_8133-scaled.jpg",
        options: null,
      },
      {
        id: 22,
        name: "Rounded Jollof",
        price: 69,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRNe4HSP_j21Au2CAxVmAIVLu0xwsWBFPV27g&s",
        options: null,
      },
      {
        id: 23,
        name: "Fried Rice",
        price: 60,
        image:
          "https://www.onceuponachef.com/images/2023/12/Fried-Rice-Hero-12.jpg",
        options: null,
      },
      {
        id: 24,
        name: "Ghana Special",
        price: 149,
        image: "https://i.ytimg.com/vi/tEZRvpj6ptM/maxresdefault.jpg",
        options: null,
      },
    ],
  }),
  async mounted() {
    this.$store.commit("setLoader", true);
    this.logos = await helpersJs.getLogos(this.getUserCompany.emis);
    await productsAndServices.getAllProductsInStock();
    this.$store.commit("setLoader", false);
  },
  methods: {
    numberFormat(number) {
      return (number || "")
        .toString()
        .replace(/^0|\./g, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    },
    formatMoney(amount) {
      return amount
        ? `${this.getCurrency}${helpersJs.formatMoney(amount)}`
        : `${this.getCurrency}0`;
    },
    // async startWithSampleData() {
    //   const response = await fetch("data/sample.json");
    //   const data = await response.json();
    //   this.products = data.products;
    //   for (const product of data.products) {
    //     await this.db.addProduct(product);
    //   }

    //   this.setFirstTime(false);
    // },
    // startBlank() {
    //   this.setFirstTime(false);
    // },
    // setFirstTime(firstTime) {
    //   this.firstTime = firstTime;
    //   if (firstTime) {
    //     localStorage.removeItem("first_time");
    //   } else {
    //     localStorage.setItem("first_time", new Date().getTime());
    //   }
    // },
    // filteredProducts() {
    //   const rg = this.keyword ? new RegExp(this.keyword, "gi") : null;
    //   return this.products.filter((p) => !rg || p.name.match(rg));
    // },
    addToCart(product) {
      const index = this.findCartIndex(product);
      if (index === -1) {
        this.cart.push({
          productId: product.id,
          image: product.image,
          name: product.name,
          price: product.price,
          option: product.option,
          qty: 1,
        });
      } else {
        this.cart[index].qty += 1;
      }
      this.beep();
      this.updateChange();
    },
    findCartIndex(product) {
      return this.cart.findIndex((p) => p.productId === product.id);
    },
    addQty(item, qty) {
      const index = this.cart.findIndex((i) => i.productId === item.productId);
      if (index === -1) {
        return;
      }
      const afterAdd = item.qty + qty;
      if (afterAdd === 0) {
        this.cart.splice(index, 1);
        this.clearSound();
      } else {
        this.cart[index].qty = afterAdd;
        this.beep();
      }
      this.updateChange();
    },
    addCash(amount) {
      this.cash = (this.cash || 0) + amount;
      this.updateChange();
      this.beep();
    },
    getItemsCount() {
      return this.cart.reduce((count, item) => count + item.qty, 0);
    },
    updateChange() {
      this.change = Number(this.cash) - Number(this.getTotalPrice()).toFixed(2);
    },
    updateCash(value) {
      const cash = parseFloat(value.replace(/[^0-9]+/g, ""));
      this.cash = cash ? cash : 0;
      this.updateChange();
    },
    getTotalPrice() {
      return this.cart.reduce(
        (total, item) => total + item.qty * item.price,
        0
      );
    },
    submit() {
      if (this.cart.length < 1) {
        alert("At Least You Need to Select 1 Item");
      } else {
        const time = new Date();
        this.isShowModalReceipt = true;
        this.receiptNo = `POS-${Math.round(time.getTime() / 1000)}`;
        this.receiptDate = this.dateFormat(time);
      }
    },
    closeModalReceipt() {
      this.isShowModalReceipt = false;
    },
    dateFormat(date) {
      const formatter = new Intl.DateTimeFormat("id", {
        dateStyle: "short",
        timeStyle: "short",
      });
      return formatter.format(date);
    },

    clear() {
      this.cash = 0;
      this.cart = [];
      this.receiptNo = null;
      this.receiptDate = null;
      this.updateChange();
      this.clearSound();
    },
    beep() {
      this.playSound("sound/beep-29.mp3");
    },
    clearSound() {
      this.playSound("sound/button-21.mp3");
    },
    playSound(src) {
      let sound = new Audio();
      sound.src = src;
      sound.play();
      sound.onended = () => (sound = null);
    },
  },
};
</script>

<style scoped lang="scss">
@import url("./style.css");
</style>
